
export const AppMenus = {
    
	navbarTopRight: [],
	navbarTopLeft: [],
	navbarSideLeft: [
  {
    "to": "/home",
    "label": "Dashboard",
    "icon": "pi pi-microsoft",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tbsekolah",
    "label": "Daftar Sekolah",
    "icon": "pi pi-save",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tbdaftarsek",
    "label": "Sekolah Berdaftar",
    "icon": "pi pi-building",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/konfigurasi",
    "label": "Konfigurasi",
    "icon": "pi pi-cog",
    "iconcolor": "",
    "target": "_self",
    
  },
  {
    "to": "/tbdaftarsek/listsemak",
    "label": "Status Markah",
    "icon": "pi pi-file",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tbdaftarsek/listsekolah",
    "label": "Sekolah",
    "icon": "pi pi-building",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tbtahunujian/listmasukmarkah",
    "label": "Masuk Markah",
    "icon": "pi pi-book",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tbtahunujian",
    "label": "Ujian",
    "icon": "pi pi-box",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/users",
    "label": "Pengguna",
    "icon": "pi pi-user-plus",
    "iconcolor": "",
    "target": "",
    
  }
],
	jantina: [    
{value: "L", label: "Lelaki"},
	{value: "P", label: "Perempuan"}
    ],
	status: [    
{value: "Ya", label: "Ya"},
	{value: "Tidak", label: "Tidak"}
    ],
	catatan: [    
{value: "SJKC", label: "SJKC"},
	{value: "SJKT", label: "SJKT"}
    ],
	statusSekolah: [    
{value: "Aktif", label: "Aktif"},
	{value: "Tidak Aktif", label: "Tidak Aktif"}
    ],
	konfigurasiKonfigurasiStaticmenu: [
  {
    "to": "/tbdaftarsek/listdaftaradmin",
    "label": "Sekolah Berdaftar",
    "icon": "pi pi-caret-right",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tbsekolah/listsekolahadmin",
    "label": "Senarai Sekolah",
    "icon": "pi pi-caret-right",
    "iconcolor": "",
    "target": "",
    
  },
  {
    "to": "/tbdaftarcalon/listlaporanadmin",
    "label": "Laporan Keseluruhan",
    "icon": "pi pi-caret-right",
    "iconcolor": "",
    "target": "",
    
  }
],

    exportFormats: {
        print: {
			label: 'Print',
            icon: 'pi pi-print',
            type: 'print',
            ext: 'print',
        },
        pdf: {
			label: 'Pdf',
			
            icon: 'pi pi-file-pdf',
            type: 'pdf',
            ext: 'pdf',
        },
        excel: {
			label: 'Excel',
            icon: 'pi pi-file-excel',
            type: 'excel',
            ext: 'xlsx',
        },
        csv: {
			label: 'Csv',
            icon: 'pi pi-table',
            type: 'csv',
            ext: 'csv',
        },
    },
    
}